import { units } from '@m/alchemy-ui';
import styled from 'styled-components';

export const StyleLocalNotificationContainer = styled.div`
    padding-bottom: ${units(2)};
`;